<template>
  <div class="topic">
    <el-card class="box-card topic-card">
      <div v-if="type == 'topics'" slot="header" class="clearfix">
        <a href="">所有帖子</a>
        <a href="?filter=elite">精华</a>
        <a href="?filter=dateline">发帖时间</a>
        <a href="?filter=no_reply">未回复</a>
      </div>
      <div v-if="type == 'top'" slot="header" class="clearfix">
        <a href="">置顶帖</a>
      </div>
      <el-row class="topic-item" v-for="item in values" :key="item.id">
        <el-col
          :xs="24"
          :sm="24"
          :md="18"
          :lg="18"
          :xl="18"
          class="topic-item-value"
        >
          <div>
            <router-link :to="{ path: '/article/'+item.user.id+'/' + item.id + '.html' }" v-if="item.postType && item.postType === 'article'">
         
              <el-tag
                type="success"
                size="mini"
                v-if="item.postType && item.postType === 'article'"
                style="margin-right: 5px"
                >文章</el-tag
              >
              {{ item.title }}
            </router-link>


            <router-link :to="{ path: '/thread-' + item.id + '-1.html' }" v-else>
              <el-tag
                type="warning"
                size="mini"
                v-if="item.postType && item.postType === 'file'"
                style="margin-right: 5px"
                >寻找文件</el-tag
              >
              <el-tag
                type="primary"
                size="mini"
                v-if="item.postType && item.postType === 'question'"
                style="margin-right: 5px"
                >技术问答</el-tag
              >
              {{ item.title }}


             
            </router-link>



          </div>
          <div class="topic-item-value-data">
            <i class="el-icon-s-data text-wch"></i> {{ item.readNum }}
            <i class="el-icon-s-comment text-wch"></i>{{ item.replyNum }}
            <el-tag
                type="primary"
                size="mini"
                v-for="i in item.tags"
                :key="i"
                class="product-tag"
                
                >{{ i }}</el-tag
              >
          </div>
        </el-col>

        <div class="topic-item-ext hidden-sm-and-down">
          <div>
            <div>
              发表人:
              <span class="text-highlinght">{{
                item.user && item.user.nickname ? item.user.nickname : "-"
              }}</span>
            </div>

            最新回复:
            <span class="text-highlinght">{{ item.lastReplyUser }}</span>
            {{ $dayjs(item.lastReplyTime).format("YYYY-MM-DD HH:mm:ss") }}
          </div>

          <UserAvatar :size="40" :user="item.user" />
        </div>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import UserAvatar from "@/components/UserAvatar";
export default {
  props: {
    values: {
      required: true,
    },
    type: {
      type: String,
      default: "topics",
    },
  },
  created() {
    // console.info(this.values);
  },
  data() {
    return {};
  },
  components: {
    UserAvatar,
  },
  methods: {},
};
</script>
<style lang="less">
.el-pagination {
  margin-top: 10px;
  margin-bottom: 10px;
}

.topic-card {
  .el-card__header {
    height: 30px;
    background-color: #1483dc;
    border-radius: 0px;
    padding: 0px;
    text-align: left;
    padding-left: 20px;
    padding-right: 20px;

    a {
      color: #fff;
      line-height: 30px;
      margin-left: 5px;
    }
  }
}

.topic-item {
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 10px;
  border-bottom: 1px dashed #969696;
  min-height: 52px;
  display: flex;

  &:last-child {
    border-bottom: none !important;
  }
}

.topic-item-value {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  // width: 60%;
}

.topic-item-value-data {
  margin-top: 5px;
}

.topic-item-ext {
  text-align: right;
  width: 40%;
  display: flex;
  justify-content: flex-end;
  .el-avatar {
    margin-left: 5px;
    margin-right: 5px;
  }
}
</style>
